var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Books',
        to: '/ebooks'
      }, {
        label: 'Bulk Update File Books',
        to: '/items/bulk/upload/books'
      }, {
        label: 'Log Activity',
        to: '/items/bulk/log_activity/books'
      }, {
        label: _vm.formattedDateTime
      }],
      "title": _vm.formattedDateTime
    }
  }), _c('div', {
    staticClass: "border rounded-xl overflow-hidden mb-5 bg-white p-3"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex items-center px-3 py-4 my-1 pt-3 text-xs font-semibold"
  }, [_c('Label', {
    staticClass: "mr-2"
  }, [_vm._v("Filter: ")]), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterStatus,
      expression: "filterStatus"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "radio",
      "value": "all",
      "disabled": _vm.isLoading
    },
    domProps: {
      "checked": _vm._q(_vm.filterStatus, "all")
    },
    on: {
      "change": [function ($event) {
        _vm.filterStatus = "all";
      }, _vm.filterByStatus]
    }
  }), _vm._v(" All ")]), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterStatus,
      expression: "filterStatus"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "radio",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": _vm.STATUS.SUCCESS,
      "checked": _vm._q(_vm.filterStatus, _vm.STATUS.SUCCESS)
    },
    on: {
      "change": [function ($event) {
        _vm.filterStatus = _vm.STATUS.SUCCESS;
      }, _vm.filterByStatus]
    }
  }), _vm._v(" Successfully (" + _vm._s(this.successCount) + ") ")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterStatus,
      expression: "filterStatus"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "radio",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": _vm.STATUS.FAILED,
      "checked": _vm._q(_vm.filterStatus, _vm.STATUS.FAILED)
    },
    on: {
      "change": [function ($event) {
        _vm.filterStatus = _vm.STATUS.FAILED;
      }, _vm.filterByStatus]
    }
  }), _vm._v(" Failed (" + _vm._s(this.failedCount) + ") ")])], 1), _c('div', {
    staticClass: "border rounded-xl overflow-hidden"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.filteredItems,
      "withNumberCol": false,
      "row-key": ['file_name', 'item_id', 'file_size', 'format_file', 'status', 'error'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": 15
    },
    scopedSlots: _vm._u([{
      key: "file_size",
      fn: function (_ref) {
        var value = _ref.value;
        return [_vm._v(" " + _vm._s(_vm.formatSize(value)) + " ")];
      }
    }, {
      key: "format_file",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('span', {
          staticClass: "uppercase"
        }, [_vm._v(_vm._s(value))])];
      }
    }, {
      key: "status",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('span', {
          staticClass: "rounded-lg text-xs p-1.5",
          class: _vm.getStatusMeta(value).class
        }, [_vm._v(" " + _vm._s(_vm.getStatusMeta(value).label) + " ")])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-orange-50 h-auto py-2 px-3 rounded-lg flex-col w-full"
  }, [_c('div', {
    staticClass: "flex items-baseline justify-start"
  }, [_c('img', {
    staticClass: "w-4 h-5 mr-2 relative top-1",
    attrs: {
      "src": require("../../assets/img/information-circle.svg")
    }
  }), _c('label', {
    staticClass: "text-sm font-semibold text-yellow-800 mb-2"
  }, [_vm._v("Upload Completed")])]), _c('p', {
    staticClass: "text-xs mt-0 text-yellow-800"
  }, [_vm._v("Your files have been successfully uploaded and moved to “Need Approval” status. If any files failed to process, please re-upload them.")])]);
}]

export { render, staticRenderFns }